export const LEGAL_UPDATED_AT = "5 août 2026";

export const LEGAL_CONTACT = Object.freeze({
  email: "harmonauria.music@gmail.com",
  publisherName: "Jérémy Tondini",
  status: "Entrepreneur individuel sous le régime de la micro-entreprise",
  siren: "904 428 570",
  siret: "904 428 570 00025",
});
